export default __webpack_public_path__ + "static/media/Hubista-Facebook-share.e055d584.png";